import { FormattedMessage } from "react-intl";

// 404 catch-all rendered by the router's "*" route.
export function NotFoundPage() {
  return (
    <section className="mx-auto max-w-screen-md px-4 py-16 text-center">
      <h1 className="text-2xl font-semibold">
        <FormattedMessage id="common.notFound" defaultMessage="Not found" />
      </h1>
      <p className="mt-2 text-sm text-ink/55">
        <FormattedMessage
          id="common.notFoundBody"
          defaultMessage="The page you're looking for doesn't exist."
        />
      </p>
    </section>
  );
}
